<template lang="html">
  <div id="app" class="wrapper" :class="{expanded:!isCollapseNavLeft, isMobile: isMobile}">
    <NavLeft class="navLeft" :isCollapseNavLeft="isCollapseNavLeft" @setCollapse="setCollapse"/>
    <NavTop/>
    <div class="main-container">
      <el-main>
        <router-view/>
      </el-main>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import NavLeft from "./parts/NavLeft";
import NavTop from "./parts/NavTop";

export default {
  name: 'CoreMain',
  data() {
    return {
      isCollapseNavLeft: false,
      isMobile: false
    };
  },
  methods: {

    setCollapse(v) {
      this.isCollapseNavLeft = v
    }
  },
  components: {
    NavTop,
    NavLeft
  },
  computed: {
    ...mapGetters('Auth', ['getPermissions'])
  },
  mounted() {
    let self = this
    if (window.innerWidth <= '1300') {
      self.setCollapse(true)
    } else {
      self.setCollapse(false)
    }
    if (window.innerWidth <= '630') {
      self.isMobile = true
    } else {
      self.isMobile = false
    }
    window.addEventListener("resize", function () {
      if (this.innerWidth <= '1300') {
        self.setCollapse(true)
      } else {
        self.setCollapse(false)
      }
      if (this.innerWidth <= '630') {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }, false);
  },
  created() {
    let perm = this.getPermissions
    let access = ['public']
    perm.map((b) => {
      access.push(b)
      return b
    })
    this.access = access
  }
}
</script>
